import firebase from 'firebase';
import { useState, useEffect } from 'react';
import { inProgressOrdersListener, pastOrderListener } from '~/firebase/listener';

import { OrderWithId } from '~/types';

export default function useInProgressOrders(storeId: string, user: firebase.User | null) {
  const [orders, setOrders] = useState<Array<OrderWithId>>([]);
  const [pastOrders, setPastOrders] = useState<Array<OrderWithId>>([]);
  const [pastOrderNum, setPastOrderNum] = useState<number>(5);
  const [isNoMorePastOrders, setIsNoMorePastOrders] = useState<boolean>(false);

  const handleUpdateOrders = (orders: Array<OrderWithId>) => {
    setOrders(orders);
  };

  const handleUpdatePastOrders = (orders: Array<OrderWithId>) => {
    if (orders.length === pastOrders.length) {
      setIsNoMorePastOrders(true);
      return;
    }
    setPastOrders(orders);
  };

  const handleMorePastOrder = () => {
    setPastOrderNum((prev) => prev + 5);
  };

  useEffect(() => {
    let ordersUnlisten: (() => void) | null = null;

    if (storeId && user) {
      ordersUnlisten = inProgressOrdersListener(storeId, user, handleUpdateOrders);
    }
    return () => {
      ordersUnlisten?.();
    };
  }, [storeId, user]);

  useEffect(() => {
    let pastOrdersUnlisten: (() => void) | null = null;

    if (storeId && user) {
      pastOrdersUnlisten = pastOrderListener(storeId, user, pastOrderNum, handleUpdatePastOrders);
    }
    return () => {
      pastOrdersUnlisten?.();
    };
  }, [storeId, user, pastOrderNum]);

  return { inProgressOrdersList: orders, pastOrders, isNoMorePastOrders, handleMorePastOrder };
}
